import { SWRConfiguration } from 'swr'
import { Investment, getInvestments } from '@/services/api/investment'
import useAuth from '@/services/hooks/useAuth'
import useApi from '../useApiV2'

const useInvestments = (config?: SWRConfiguration) => {
  const { user } = useAuth()

  const { data, ...rest } = useApi<Investment[]>({
    key: user ? 'investments' : false,
    request: getInvestments,
    config,
  })

  return { investments: data, ...rest }
}

export default useInvestments
